import script from "./PriceRangeFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceRangeFilter.vue?vue&type=script&setup=true&lang=js"

import "./PriceRangeFilter.vue?vue&type=style&index=0&id=47c74b38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47c74b38"]])

export default __exports__